import axios from 'axios'

import { Search } from '@giscube/geoportal'

export default class AdvancedSearch extends Search {
  setICGCSearch (q, layers) {
    const search = this.$config.geocodificadorICGC
    if (search) {
      const config = {
        params: {
          text: q,
          layers: layers,
          ...this.$config.geocodificadorICGC.params
        }
      }
      this.promises.push(new Promise((resolve, reject) => {
        axios.get(search.url, config)
          .then(response => {
            resolve(this.parseICGCResult({ search, data: response.data }))
          })
          .catch(reject)
      }))
    }
  }

  parsePKFerroviariResult ({ search, data }) {
    let results = []

    data.features.forEach(element => {
      let result = {
        title: `PK ${element.properties[search.param]}`,
        subtitle: search.title,
        geojson: element,
        origin: {
          name: 'icgc',
          title: search.title
        }
      }
      results.push(result)
    })

    return results
  }

  setPKFerroviariSearch (q) {
    const [type, value] = q.split('=')
    const search = this.$config.pkFerroviariICGC[type]
    if (search) {
      const config = {
        params: {
          filter: `${search.param}=${value}`,
          limit: 1
        }
      }
      this.promises.push(new Promise((resolve, reject) => {
        axios.get(search.url, config)
          .then(response => {
            resolve(this.parsePKFerroviariResult({ search, data: response.data }))
          })
          .catch(reject)
      }))
    }
  }

  setGeoAPISearch (q, searches, contentType) {
    searches.forEach(search => {
      const config = {
        params: {
          q: q,
          e: contentType
        }
      }
      this.promises.push(new Promise((resolve, reject) => {
        axios.get(search.url, config)
          .then(response => {
            resolve(this.parseResult({ search, data: response.data }))
          })
          .catch(reject)
      }))
    })
  }

  getSearches () {
    let searches = []
    if (this.$context.state.searchOption === 'layer') {
      searches = this.$config.searches.filter(search => search.name === 'geoportal')
    }
    return searches
  }

  setAllSearches (q) {
    if (this.$context.state.searchOption === 'coords') {
      this.setCoordsSearch(q)
    } else if (this.$context.state.searchOption === 'address') {
      const searches = this.$config.searches.filter(search => search.address)
      if (searches.length > 0) {
        this.setGeoAPISearch(q, searches, 'address')
      }
    } else if (this.$context.state.searchOption === 'refcad') {
      const searches = this.$config.searches.filter(search => search.refcad)
      if (searches.length > 0) {
        this.setGeoAPISearch(q, searches, 'refcad')
      }
    } else if (this.$context.state.searchOption === 'addressICGC' && this.$config.geocodificadorICGC) {
      const layers = /\d/.test(q) ? 'address' : 'topo1,topo2'
      this.setICGCSearch(q, layers)
    } else if (this.$context.state.searchOption === 'pk') {
      this.setICGCSearch(q, 'pk')
    } else if (this.$context.state.searchOption === 'pkFerroviari') {
      this.setPKFerroviariSearch(q)
    } else {
      super.setSearches(q)
    }
  }
}
